import IsLoading from '@/components/layouts/IsLoading';
import InstitutionContext, { IInstitutionContext } from '@/contexts/data/InstitutionContext';
import InstitutionsContext from '@/contexts/data/InstitutionsContext';
import { FC, PropsWithChildren, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';


export interface IInstitutionProviderProps {
}

export const InstitutionProvider: FC<PropsWithChildren<IInstitutionProviderProps>> = ({ children }) => {
    const institutions = useContext(InstitutionsContext);

    const institutionId = useParams()?.institutionId;

    const institution  = useMemo(() => {
        if (!institutionId) {
            return {
                data: undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as IInstitutionContext;
        }

        const instId = +institutionId;

        return {
            data: institutions.data?.find(x => x.id?.toString() === institutionId),
            id: instId,
            error: institutions.error,
            loading: institutions.loading,
            validating: institutions.validating,
            refresh: async () => {
                const newData = await institutions.refresh();

                return newData?.find(x => x.id?.toString() === institutionId);
            },
        } as IInstitutionContext
    }, [institutions, institutionId]);

    return (

        <InstitutionContext.Provider value={institution}>
            <IsLoading name="institution" loading={institution.loading} validating={institution.validating}/>
            {children}
        </InstitutionContext.Provider>
    );
}

export default InstitutionProvider;
